// extracted by mini-css-extract-plugin
module.exports =  {"SingleLineText":"SingleLineText__WSko6"};